import { defineGameCard, beforeDamage, oncePerRound, roundMarkerStatus, } from '../authoring/index.js';
const REDUCTION_ROUND_KEY = '@cards/ability/soft_sofa/damage_reduction/round';
export const SoftSofaCard = defineGameCard({
    id: 'soft_sofa',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 7 } },
    presentation: {
        name: 'Мягкий диван',
        description: 'Первый раз за раунд уменьшает входящий урон на 2, но не ниже 0. Нулевой урон способность не расходует.',
        glyph: {
            colors: ['#10213A', '#A1653F', '#7E492C', '#814A2D', '#4C2D23'],
            rows: [
                '....................',
                '....................',
                '....................',
                '...11111111111111...',
                '..1222222333322221..',
                '..1222444444444221..',
                '..1244444444444421..',
                '..1144444444444411..',
                '.123444444444441421.',
                '14431555555555553441',
                '13351111111111155431',
                '.145222222222221531.',
                '.135444444444441541.',
                '.145355555555551541.',
                '.135111111111111531.',
                '..1111111111111111..',
                '..51............15..',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        beforeDamage(oncePerRound({
            abilityId: 'damage_reduction',
            trigger: 'interceptIncomingDamage',
            when(ctx, planned) {
                return ctx.self !== undefined
                    && planned.target.kind === 'unit'
                    && planned.target.instanceId === ctx.self.id
                    && planned.amount > 0;
            },
            run(_ctx, planned) {
                return Math.max(0, planned.amount - 2);
            },
        })),
    ],
    ui: {
        publicVars: {
            reductionRound: { key: REDUCTION_ROUND_KEY, kind: 'number' },
        },
        statusProviders: [roundMarkerStatus({
                fact: 'reductionRound',
                id: 'soft-sofa-used',
                symbol: '−2',
                label: 'Смягчение использовано',
                description: 'Диван уже уменьшал входящий урон в этом раунде.',
                tone: 'positive',
            })],
    },
});
//# sourceMappingURL=soft_sofa.js.map